import { render, staticRenderFns } from "./AbkNewPageContentForm.vue?vue&type=template&id=79a719b8&scoped=true&"
import script from "./AbkNewPageContentForm.vue?vue&type=script&lang=js&"
export * from "./AbkNewPageContentForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewPageContentForm.vue?vue&type=style&index=0&id=79a719b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a719b8",
  null
  
)

export default component.exports